export {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  TimelineOppositeContent,
  type TimelineConnectorProps,
  type TimelineContentProps,
  type TimelineDotProps,
  type TimelineItemProps,
  type TimelineOppositeContentProps,
  type TimelineProps,
  type TimelineSeparatorProps,
} from '@mui/lab';
